<template>
  <div class="header-container">
    <div class="container">
      <div class="logo">
        <img src="~@/assets/images/logo.svg" @click="goToSenguo"/>
        <span>{{ headTitle }}</span>
      </div>
      <!-- <div class="user">
        <img class="wx-img" :src="$store.state.userInfo.avatar" alt="微信头像">
        <div class="wx-information">
          <p class="nikename">{{ $store.state.userInfo.nickname }}</p>
          <p class="phone">{{ $store.state.userInfo.phone }}</p>
        </div>
        <i class="el-icon-arrow-down tip"></i>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headTitle: ''
    }
  },
  computed: {
    ...mapState({
      shopInfo: state => state.shopInfo,
      userInfo: state => state.userInfo,
    })
  },
  created() {
    this.headTitle = this.$route.meta.headTitle;
  },
  methods: {
    goToSenguo() {
      window.open('https://www.senguo.cc')
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  width: 100%;
  height: 60px;
  background: #F7F7F7;
  user-select: none;
  color: #333333;

  .container {
    position: relative;
    width: 1080px;
    height: 60px;
    margin: 0 auto;

    .logo {
      position: absolute;
      top: 10px;
      left: 0;
      display: flex;
      align-items: center;

      img {
        width: 100px;
        height: 40px;
        cursor: pointer;
      }

      span {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: 500;
        line-height: 1;
        color: #333;
        letter-spacing: 0;

        &::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 32px;
          background: #d8d8d8;
          margin: 0 12px;
        }
      }
    }

    // .user {
    //   position: absolute;
    //   top: 10px;
    //   right: 10px;
    //   height: 40px;
    //   font-size: 14px;
    //   line-height: 20px;


    //   .wx-img {
    //     display: inline-block;
    //     width: 40px;
    //     height: 40px;
    //     margin-right: 10px;
    //     border: 1px solid #3C90FF;
    //     border-radius: 50%;
    //   }

    //   .wx-information {
    //     display: inline-block;
    //     position: relative;
    //     top: -4px;
    //   }

    //   .tip {
    //     position: relative;
    //     top: -12px;
    //     margin-left: 10px;
    //   }
    // }
    
  }
}
</style>
